import { useNavigate } from 'react-router-dom';
import PortalButton from '../components/Button';
import StatusTag from '../components/StatusTag';
import { useEffect, useState } from 'react';
import {
  agreementFields,
  qualificationFields,
  workExperienceFields,
} from '../api/applicationData';
import { useAuth } from '../context/AuthContext';
function MyApplications() {
  let navigate = useNavigate();
  const { user, applicantData } = useAuth();
  return (
    <>
      <StatusTag
        status={
          applicantData?.applicationStatus
            ? applicantData?.applicationStatus
            : null
        }
      />
      <div className="flex justify-center space-y-10 mt-2 sm:mt-6">
        <div className="flex flex-col w-full items-center justify-center bg-[#f7f8fb] rounded-xl p-16">
          {(applicantData == null ||
            applicantData?.applicationStatus === null) && (
            <div>
              <div className="text-center flex flex-col items-center">
                <svg
                  id="Layer_1"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                  data-name="Layer 1"
                  style={{ width: '60px', height: '60px', color: '#ADB5BD' }}
                  className="mx-auto mb-4">
                  <path
                    d="M23.121.879a3.002 3.002 0 0 0-4.242 0l-6.707 6.707A3.971 3.971 0 0 0 11 10.414V12a1 1 0 0 0 1 1h1.586a3.975 3.975 0 0 0 2.828-1.172l6.707-6.707c1.164-1.117 1.164-3.126 0-4.243zm-1.414 2.828L15 10.414c-.378.378-.88.586-1.414.586H13v-.586c0-.526.214-1.042.586-1.414l6.707-6.707a1 1 0 0 1 1.414 0 1.004 1.004 0 0 1 0 1.414zM12 18a1 1 0 1 1 0-2h3a1 1 0 1 1 0 2zm8-4v5c0 2.757-2.243 5-5 5H5c-2.757 0-5-2.243-5-5V5c0-2.757 2.243-5 5-5h9a1 1 0 1 1 0 2H5C3.346 2 2 3.346 2 5v14c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3v-5a1 1 0 1 1 2 0zM9.167 11.667 7.48 13.354a2.2 2.2 0 0 1-3.052.066l-.669-.579a1.001 1.001 0 0 1 1.31-1.512l.689.598c.103.093.228.092.307.013l1.687-1.687a.999.999 0 1 1 1.414 1.414zm0-4.96L7.48 8.394a2.2 2.2 0 0 1-3.052.066l-.669-.579a1.001 1.001 0 0 1 1.31-1.512l.689.598c.103.094.228.092.307.013l1.687-1.687a.999.999 0 1 1 1.414 1.414zm0 8.546a.999.999 0 0 1 0 1.414L7.48 18.354a2.2 2.2 0 0 1-3.052.066l-.669-.579a1.001 1.001 0 0 1 1.31-1.512l.689.598c.103.093.228.092.307.013l1.687-1.687a.999.999 0 0 1 1.414 0z"
                    fill="#adb5bd"
                    opacity="1"
                    data-original="#000000"
                    className=""></path>
                </svg>
                <div className="text-portal-600 text-2xl font-semibold mb-2 text-center">
                  No application submitted!
                </div>
                <p className="mb-4">
                  You haven’t submitted your application yet.{' '}
                  <a href="/apply" target="_self">
                    Click here to submit your application
                  </a>{' '}
                  to get started!
                </p>
                <PortalButton
                  variant="primary"
                  text="Start Application"
                  onClick={() => navigate('/apply')}
                  classes="w-64"
                />
              </div>
            </div>
          )}
          {applicantData?.applicationStatus === 'applicationStarted' && (
            <div className="text-center flex flex-col items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                id="Layer_1"
                data-name="Layer_1"
                viewBox="0 0 24 24"
                style={{ width: '60px', height: '60px', color: '#A0DCE1' }}
                className="mx-auto mb-4">
                <path
                  d="M10 23a1 1 0 0 1-1 1H5c-2.757 0-5-2.243-5-5V5c0-2.757 2.243-5 5-5h8c2.757 0 5 2.243 5 5v2a1 1 0 1 1-2 0V5c0-1.654-1.346-3-3-3H5C3.346 2 2 3.346 2 5v14c0 1.654 1.346 3 3 3h4a1 1 0 0 1 1 1Zm4-17a1 1 0 0 0-1-1H5a1 1 0 1 0 0 2h8a1 1 0 0 0 1-1Zm-4 5a1 1 0 0 0-1-1H5a1 1 0 1 0 0 2h4a1 1 0 0 0 1-1Zm-5 4a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2H5Zm19 2c0 3.859-3.141 7-7 7s-7-3.141-7-7 3.141-7 7-7 7 3.141 7 7Zm-2 0c0-2.757-2.243-5-5-5s-5 2.243-5 5 2.243 5 5 5 5-2.243 5-5Zm-3.192-1.241-2.223 2.134a.374.374 0 0 1-.522.002l-1.131-1.108a.999.999 0 1 0-1.4 1.428l1.132 1.109c.46.449 1.062.674 1.663.674s1.201-.225 1.653-.671l2.213-2.124a1 1 0 0 0-1.385-1.443Z"
                  fill="#a0dce1"
                  opacity="1"></path>
              </svg>
              <div className="text-portal-600 text-2xl font-semibold mb-2 text-center">
                Thank you!
              </div>
              <p>
                Your application process has just begun. Please continue with
                the next steps.
              </p>
            </div>
          )}
          {applicantData?.applicationStatus === 'applicationSubmitted' && (
            <div className="text-center flex flex-col items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                id="Layer_1"
                data-name="Layer_1"
                viewBox="0 0 24 24"
                style={{ width: '60px', height: '60px', color: '#A0DCE1' }}
                className="mx-auto mb-4">
                <path
                  d="M10 23a1 1 0 0 1-1 1H5c-2.757 0-5-2.243-5-5V5c0-2.757 2.243-5 5-5h8c2.757 0 5 2.243 5 5v2a1 1 0 1 1-2 0V5c0-1.654-1.346-3-3-3H5C3.346 2 2 3.346 2 5v14c0 1.654 1.346 3 3 3h4a1 1 0 0 1 1 1Zm4-17a1 1 0 0 0-1-1H5a1 1 0 1 0 0 2h8a1 1 0 0 0 1-1Zm-4 5a1 1 0 0 0-1-1H5a1 1 0 1 0 0 2h4a1 1 0 0 0 1-1Zm-5 4a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2H5Zm19 2c0 3.859-3.141 7-7 7s-7-3.141-7-7 3.141-7 7-7 7 3.141 7 7Zm-2 0c0-2.757-2.243-5-5-5s-5 2.243-5 5 2.243 5 5 5 5-2.243 5-5Zm-3.192-1.241-2.223 2.134a.374.374 0 0 1-.522.002l-1.131-1.108a.999.999 0 1 0-1.4 1.428l1.132 1.109c.46.449 1.062.674 1.663.674s1.201-.225 1.653-.671l2.213-2.124a1 1 0 0 0-1.385-1.443Z"
                  fill="#a0dce1"
                  opacity="1"></path>
              </svg>
              <div className="text-portal-600 text-2xl font-semibold mb-2 text-center">
                Thank you!
              </div>
              <p>
                Your application has been successfully submitted. Our team will
                review your information and will be in touch soon. Be sure to
                check your text and email for updates.
              </p>
            </div>
          )}
          {applicantData?.applicationStatus === 'activated' && (
            <div className="text-center flex flex-col items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                style={{ width: '70px', height: '70px', color: '#C3E6CB' }}
                className="mx-auto mb-4">
                <path
                  d="M17.5 24c-3.584 0-6.5-2.916-6.5-6.5s2.916-6.5 6.5-6.5 6.5 2.916 6.5 6.5-2.916 6.5-6.5 6.5Zm0-11c-2.481 0-4.5 2.019-4.5 4.5s2.019 4.5 4.5 4.5 4.5-2.019 4.5-4.5-2.019-4.5-4.5-4.5Zm.999 6.354 1.886-1.833a1 1 0 0 0-1.393-1.434L17.1 17.925c-.099.1-.262.1-.362 0l-.876-.858a1 1 0 0 0-1.399 1.43l.876.858c.437.428 1.01.641 1.582.641s1.146-.215 1.579-.643ZM9 12c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6ZM9 2C6.794 2 5 3.794 5 6s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4ZM2 23c0-3.524 2.633-6.511 6.124-6.946.548-.068.937-.568.869-1.116s-.574-.931-1.116-.868C3.386 14.629 0 18.469 0 23a1 1 0 1 0 2 0Z"
                  fill="#c3e6cb"
                  opacity="1"></path>
              </svg>
              <div className="text-portal-600 text-2xl font-semibold mb-2 text-center">
                Welcome aboard!
              </div>
              <p>
                You’re now active as a Laundry Care Provider! Check your email
                for next steps to set up your Profile in the Provider App.
              </p>
            </div>
          )}
          {applicantData?.applicationStatus === 'review' && (
            <div className="text-center flex flex-col items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                style={{ width: '70px', height: '70px', color: '#FFEB99' }}
                className="mx-auto mb-4">
                <path
                  d="M11 23a1 1 0 0 1-1 1H5c-2.757 0-5-2.243-5-5V5.001A5.006 5.006 0 0 1 4.999 0H15c2.757 0 5 2.242 5 4.999v2a1 1 0 1 1-2 0v-2c0-1.654-1.346-3-3-3H4.999c-1.654 0-3 1.347-3 3.001v13.999c0 1.654 1.346 3 3 3h5a1 1 0 0 1 1 1Zm12.553.553a.997.997 0 0 1-1.414 0l-2.666-2.666A5.968 5.968 0 0 1 16 22a6 6 0 1 1 6-6 5.968 5.968 0 0 1-1.113 3.473l2.666 2.666a.999.999 0 0 1 0 1.414Zm-6.573-5.227 2.703-2.614a1 1 0 1 0-1.385-1.443l-2.713 2.624a.372.372 0 0 1-.522 0l-1.132-1.108a1 1 0 0 0-1.399 1.43l1.132 1.108c.459.449 1.062.674 1.664.674s1.201-.225 1.653-.671ZM7 5H5a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2Zm0 10H5a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2Zm4-10a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-4Zm-4 5H5a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2Z"
                  fill="#ffeb99"
                  opacity="1"></path>
              </svg>
              <div className="text-portal-600 text-2xl font-semibold mb-2 text-center">
                We’re reviewing your application.
              </div>
              <p>
                Thank you for applying! Your application is currently under
                review by our team. Please watch your texts and email for
                updates.
              </p>
            </div>
          )}
          {applicantData?.applicationStatus === 'interview' && (
            <div className="text-center flex flex-col items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                style={{ width: '70px', height: '70px', color: '#FFE5CC' }}
                className="mx-auto mb-4">
                <path
                  d="M7.5 13A4.5 4.5 0 1 1 12 8.5 4.505 4.505 0 0 1 7.5 13zm0-7A2.5 2.5 0 1 0 10 8.5 2.5 2.5 0 0 0 7.5 6zM15 23v-.5a7.5 7.5 0 0 0-15 0v.5a1 1 0 0 0 2 0v-.5a5.5 5.5 0 0 1 11 0v.5a1 1 0 0 0 2 0zm9-5a7 7 0 0 0-11.667-5.217 1 1 0 1 0 1.334 1.49A5 5 0 0 1 22 18a1 1 0 0 0 2 0zm-6.5-9A4.5 4.5 0 1 1 22 4.5 4.505 4.505 0 0 1 17.5 9zm0-7A2.5 2.5 0 1 0 20 4.5 2.5 2.5 0 0 0 17.5 2z"
                  fill="#ffe5cc"
                  opacity="1"></path>
              </svg>
              <div className="text-portal-600 text-2xl font-semibold mb-2 text-center">
                Interview Invitation
              </div>
              <p className="mb-4">
                We're moving forward with your application and would like to set
                up a quick interview. Details have been sent to your email. We
                hope to speak with you soon!
              </p>
              <PortalButton
                variant="primary"
                text="Upload Interview Materials"
                onClick={() => navigate('/interview-media-upload')}
                classes="w-64"
              />
            </div>
          )}
          {applicantData?.applicationStatus === 'interviewReview' && (
            <div className="text-center flex flex-col items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                style={{ width: '70px', height: '70px', color: '#D4EDDA' }}
                className="mx-auto mb-4">
                <path
                  d="M19 2h-1V1a1 1 0 0 0-2 0v1H8V1a1 1 0 0 0-2 0v1H5C2.243 2 0 4.243 0 7v12c0 2.757 2.243 5 5 5h14c2.757 0 5-2.243 5-5V7c0-2.757-2.243-5-5-5ZM5 4h1v1a1 1 0 0 0 2 0V4h8v1a1 1 0 0 0 2 0V4h1c1.654 0 3 1.346 3 3v1H2V7c0-1.654 1.346-3 3-3Zm14 18H5c-1.654 0-3-1.346-3-3v-9h20v9c0 1.654-1.346 3-3 3Zm-2.293-6.707a.999.999 0 0 1 0 1.414l-4 4a.997.997 0 0 1-1.414 0l-2-2a.999.999 0 1 1 1.414-1.414L12 18.586l3.293-3.293a.999.999 0 0 1 1.414 0Z"
                  fill="#d4edda"
                  opacity="1"></path>
              </svg>
              <div className="text-portal-600 text-2xl font-semibold mb-2 text-center">
                Interview Materials Submitted!
              </div>
              <p>
                Thank you for uploading your interview materials! Our team is
                currently reviewing your submission. We'll be in touch soon with
                the next steps.
              </p>
              <p className="mt-2">
                Please keep an eye on your email and text messages for updates
                regarding your application status.
              </p>
            </div>
          )}
          {applicantData?.applicationStatus === 'onboarding' && (
            <div className="text-center flex flex-col items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                style={{ width: '70px', height: '70px', color: '#CCE5FF' }}
                className="mx-auto mb-4">
                <path
                  d="m8,12c3.309,0,6-2.691,6-6S11.309,0,8,0,2,2.691,2,6s2.691,6,6,6Zm0-10c2.206,0,4,1.794,4,4s-1.794,4-4,4-4-1.794-4-4,1.794-4,4-4Zm.992,12.938c.068.548-.32,1.047-.869,1.116-3.491.436-6.124,3.421-6.124,6.946,0,.552-.448,1-1,1s-1-.448-1-1c0-4.531,3.386-8.37,7.876-8.93.542-.069,1.047.32,1.116.869Zm13.704,4.195l-.974-.562c.166-.497.278-1.019.278-1.572s-.111-1.075-.278-1.572l.974-.562c.478-.276.642-.888.366-1.366-.277-.479-.888-.643-1.366-.366l-.973.562c-.705-.794-1.644-1.375-2.723-1.594v-1.101c0-.552-.448-1-1-1s-1,.448-1,1v1.101c-1.079.22-2.018.801-2.723,1.594l-.973-.562c-.481-.277-1.09-.113-1.366.366-.276.479-.112,1.09.366,1.366l.974.562c-.166.497-.278,1.019-.278,1.572s.111,1.075.278,1.572l-.974.562c-.478.276-.642.888-.366,1.366.186.321.521.5.867.5.169,0,.341-.043.499-.134l.973-.562c.705.794,1.644,1.375,2.723,1.594v1.101c0,.552.448,1,1,1s1-.448,1-1v-1.101c1.079-.22,2.018-.801,2.723-1.594l.973.562c.158.091.33.134.499.134.346,0,.682-.179.867-.5.276-.479.112-1.09-.366-1.366Zm-5.696.866c-1.654,0-3-1.346-3-3s1.346-3,3-3,3,1.346,3,3-1.346,3-3,3Z"
                  fill="#cce5ff"
                  opacity="1"
                />
              </svg>
              <div className="text-portal-600 text-2xl font-semibold mb-2 text-center">
                Congratulations!
              </div>
              <p>
                We're excited to offer you a contract and begin the onboarding
                process!
              </p>
              <p>
                Please check your email for important details regarding the next
                steps. Be sure to complete everything as soon as possible so we
                can get you up and running!
              </p>
              <p>
                If you don’t see the email, be sure to check your spam or junk
                folders. Questions? Reach out to HR at{' '}
                <a className="text-portal-600" href="tel:6144688656">
                  614-468-8656
                </a>{' '}
                or{' '}
                <a className="text-portal-600" href="mailto:HR@laundrycare.biz">
                  HR@laundrycare.biz
                </a>
              </p>
            </div>
          )}
          {applicantData?.applicationStatus === 'locationRejected' && (
            <div className="text-center flex flex-col items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                style={{ width: '70px', height: '70px', color: '#F8D7DA' }}
                className="mx-auto mb-4">
                <path
                  d="M15.27 13.64 13.3 16l1.97 2.36a1.001 1.001 0 1 1-1.54 1.28L12 17.56l-1.73 2.08a.99.99 0 0 1-.77.36c-.23 0-.45-.08-.64-.23-.42-.35-.48-.98-.13-1.41L10.7 16l-1.97-2.36a1.001 1.001 0 1 1 1.54-1.28L12 14.44l1.73-2.08c.35-.42.98-.48 1.41-.13.42.35.48.98.13 1.41ZM22 10.49V19c0 2.76-2.24 5-5 5H7c-2.76 0-5-2.24-5-5V5c0-2.76 2.24-5 5-5h4.51c1.87 0 3.63.73 4.95 2.05l3.48 3.49a6.96 6.96 0 0 1 2.05 4.95Zm-6.95-7.03c-.32-.32-.67-.59-1.05-.81V7c0 .55.45 1 1 1h4.34c-.22-.38-.49-.73-.81-1.05l-3.48-3.49ZM20 10.48c0-.16 0-.33-.02-.49H15c-1.65 0-3-1.35-3-3V2.02C11.84 2 11.68 2 11.51 2H7C5.35 2 4 3.35 4 5v14c0 1.65 1.35 3 3 3h10c1.65 0 3-1.35 3-3v-8.51Z"
                  fill="#f8d7da"
                  opacity="1"></path>
              </svg>
              <div className="text-portal-600 text-2xl font-semibold mb-2 text-center">
                Thank you for your interest!
              </div>
              <p>
                At this time, we’re not accepting new Providers in your area due
                to coverage needs. We’ll keep your application on file in case
                opportunities open up near you in the future.
              </p>
            </div>
          )}
          {applicantData?.applicationStatus === 'applicationRejected' && (
            <div className="text-center flex flex-col items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                style={{ width: '70px', height: '70px', color: '#F8D7DA' }}
                className="mx-auto mb-4">
                <path
                  d="M15.27 13.64 13.3 16l1.97 2.36a1.001 1.001 0 1 1-1.54 1.28L12 17.56l-1.73 2.08a.99.99 0 0 1-.77.36c-.23 0-.45-.08-.64-.23-.42-.35-.48-.98-.13-1.41L10.7 16l-1.97-2.36a1.001 1.001 0 1 1 1.54-1.28L12 14.44l1.73-2.08c.35-.42.98-.48 1.41-.13.42.35.48.98.13 1.41ZM22 10.49V19c0 2.76-2.24 5-5 5H7c-2.76 0-5-2.24-5-5V5c0-2.76 2.24-5 5-5h4.51c1.87 0 3.63.73 4.95 2.05l3.48 3.49a6.96 6.96 0 0 1 2.05 4.95Zm-6.95-7.03c-.32-.32-.67-.59-1.05-.81V7c0 .55.45 1 1 1h4.34c-.22-.38-.49-.73-.81-1.05l-3.48-3.49ZM20 10.48c0-.16 0-.33-.02-.49H15c-1.65 0-3-1.35-3-3V2.02C11.84 2 11.68 2 11.51 2H7C5.35 2 4 3.35 4 5v14c0 1.65 1.35 3 3 3h10c1.65 0 3-1.35 3-3v-8.51Z"
                  fill="#f8d7da"
                  opacity="1"></path>
              </svg>
              <div className="text-portal-600 text-2xl font-semibold mb-2 text-center">
                We appreciate your interest.
              </div>
              <p>
                After careful consideration, we will not be moving forward with
                your application. Thank you for taking the time to apply, and we
                wish you the best in your job search.
              </p>
            </div>
          )}
          {applicantData?.applicationStatus === 'expired' && (
            <div className="text-center flex flex-col items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                style={{ width: '70px', height: '70px', color: '#A2A4A7' }}
                className="mx-auto mb-4">
                <path
                  d="M10 23a1 1 0 0 1-1 1H5c-2.757 0-5-2.243-5-5V5c0-2.757 2.243-5 5-5h8c2.757 0 5 2.243 5 5v2a1 1 0 0 1-2 0V5c0-1.654-1.346-3-3-3H5C3.346 2 2 3.346 2 5v14c0 1.654 1.346 3 3 3h4a1 1 0 0 1 1 1Zm4-17a1 1 0 0 0-1-1H5a1 1 0 0 0 0 2h8a1 1 0 0 0 1-1Zm-9 9a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2H5Zm19 2c0 3.86-3.14 7-7 7s-7-3.14-7-7 3.14-7 7-7 7 3.14 7 7Zm-2 0c0-2.757-2.243-5-5-5s-5 2.243-5 5 2.243 5 5 5 5-2.243 5-5Zm-5-4a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 17 13Zm0 4a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1Zm-7-6a1 1 0 0 0-1-1H5a1 1 0 0 0 0 2h4a1 1 0 0 0 1-1Z"
                  fill="#a2a4a7"
                  opacity="1"></path>
              </svg>
              <div className="text-portal-600 text-2xl font-semibold mb-2 text-center">
                Application Expired
              </div>
              <p>
                Your application has expired due to inactivity or missing steps.
                If you’re still interested in working with us, please reach out
                to our team for further instructions. Contact HR at{' '}
                <a href="tel:6144688656">614-468-8656</a> or{' '}
                <a href="mailto:HR@laundrycare.biz">HR@laundrycare.biz</a>.
              </p>
            </div>
          )}
        </div>
      </div>
      {applicantData && (
        <div className="mx-auto p-6 bg-white rounded-lg shadow-md mt-6 space-y-8">
          <h2 className="text-2xl font-bold text-portal-600 border-b-2 border-portal-200 pb-3">
            Application Details
          </h2>

          {/* Personal Info Section */}
          <section className="bg-[#f7f8fb] p-6 rounded-lg">
            <h3 className="text-xl font-semibold text-portal-600 mb-4 flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                className="w-6 h-6 mr-2"
                fill="currentColor">
                <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
              </svg>
              Personal Information
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="bg-white p-4 rounded border border-gray-200">
                <p className="text-sm text-gray-500 mb-1">Full Name</p>
                <p className="font-semibold text-gray-800">
                  {applicantData?.personalInfo?.fullName || '—'}
                </p>
              </div>
              <div className="bg-white p-4 rounded border border-gray-200">
                <p className="text-sm text-gray-500 mb-1">Date of Birth</p>
                <p className="font-semibold text-gray-800">
                  {applicantData?.personalInfo?.dob || '—'}
                </p>
              </div>
              <div className="bg-white p-4 rounded border border-gray-200">
                <p className="text-sm text-gray-500 mb-1">Phone Number</p>
                <p className="font-semibold text-gray-800">
                  {applicantData?.personalInfo?.phone_number || '—'}
                </p>
              </div>
              <div className="bg-white p-4 rounded border border-gray-200">
                <p className="text-sm text-gray-500 mb-1">Email Address</p>
                <p className="font-semibold text-gray-800 break-words">
                  {applicantData?.email || '—'}
                </p>
              </div>
              <div className="bg-white p-4 rounded border border-gray-200">
                <p className="text-sm text-gray-500 mb-1">Referral Code</p>
                <p className="font-semibold text-gray-800">
                  {applicantData?.personalInfo?.referral_code || 'None'}
                </p>
              </div>
              <div className="bg-white p-4 rounded border border-gray-200 md:col-span-2">
                <p className="text-sm text-gray-500 mb-1">Address</p>
                <p className="font-semibold text-gray-800">
                  {applicantData?.personalInfo?.address_line_1}
                  {applicantData?.personalInfo?.address_line_2 &&
                    `, ${applicantData?.personalInfo?.address_line_2}`}
                  <br />
                  {applicantData?.personalInfo?.city},{' '}
                  {applicantData?.personalInfo?.state}{' '}
                  {applicantData?.personalInfo?.postal_code}
                </p>
              </div>
            </div>
          </section>

          {/* Qualifications Section */}
          <section className="bg-[#f7f8fb] p-6 rounded-lg">
            <h3 className="text-xl font-semibold text-portal-600 mb-4 flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                className="w-6 h-6 mr-2"
                fill="currentColor">
                <path d="M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z" />
              </svg>
              Qualifications
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              {qualificationFields.map(({ key, label }) => (
                <div
                  key={key}
                  className="bg-white p-3 rounded border border-gray-200 flex items-center justify-between">
                  <p className="text-sm text-gray-700">{label}</p>
                  <span
                    className={`px-3 py-1 rounded-full text-xs font-semibold ${
                      applicantData?.qualifications?.[key]
                        ? 'bg-green-100 text-green-800'
                        : 'bg-gray-100 text-gray-800'
                    }`}>
                    {applicantData?.qualifications?.[key] ? 'Yes' : 'No'}
                  </span>
                </div>
              ))}
            </div>
          </section>

          {/* Work Experience Section */}
          <section className="bg-[#f7f8fb] p-6 rounded-lg">
            <h3 className="text-xl font-semibold text-portal-600 mb-4 flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                className="w-6 h-6 mr-2"
                fill="currentColor">
                <path d="M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z" />
              </svg>
              Work Experience
            </h3>
            <div className="space-y-3">
              {workExperienceFields.map(({ key, label }) => (
                <div
                  key={key}
                  className="bg-white p-4 rounded border border-gray-200">
                  <p className="text-sm text-gray-500 mb-2">{label}</p>
                  <p className="text-gray-800">
                    {applicantData?.experience?.[key] || '—'}
                  </p>
                </div>
              ))}
            </div>
          </section>

          {/* Availability Section */}
          <section className="bg-[#f7f8fb] p-6 rounded-lg">
            <h3 className="text-xl font-semibold text-portal-600 mb-4 flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                className="w-6 h-6 mr-2"
                fill="currentColor">
                <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z" />
              </svg>
              Availability
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
              {applicantData?.availability?.map((dayBlock) => {
                const times = ['morning', 'afternoon', 'evening', 'none']
                  .filter((time) => dayBlock[time])
                  .map((time) => time.charAt(0).toUpperCase() + time.slice(1))
                  .join(', ');
                return (
                  <div
                    key={dayBlock.day}
                    className="bg-white p-4 rounded border border-gray-200">
                    <p className="text-sm font-semibold text-portal-600 capitalize mb-2">
                      {dayBlock.day}
                    </p>
                    <p className="text-sm text-gray-800">
                      {times || 'Not Available'}
                    </p>
                  </div>
                );
              })}
            </div>
          </section>

          {/* Agreements Section */}
          <section className="bg-[#f7f8fb] p-6 rounded-lg">
            <h3 className="text-xl font-semibold text-portal-600 mb-4 flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                className="w-6 h-6 mr-2"
                fill="currentColor">
                <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
              </svg>
              Agreements & Acknowledgments
            </h3>
            <div className="space-y-3">
              {agreementFields.map(({ key, statement }) => (
                <div
                  key={key}
                  className="bg-white p-4 rounded border border-gray-200 flex items-start">
                  <div className="flex-shrink-0 mr-3 mt-1">
                    {applicantData?.agreements?.[key] ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-6 h-6 text-green-600"
                        viewBox="0 0 24 24"
                        fill="currentColor">
                        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-6 h-6 text-gray-400"
                        viewBox="0 0 24 24"
                        fill="currentColor">
                        <path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" />
                      </svg>
                    )}
                  </div>
                  <div className="flex-1">
                    <p className="text-sm text-gray-700">{statement}</p>
                    <span
                      className={`inline-block mt-2 px-3 py-1 rounded-full text-xs font-semibold ${
                        applicantData?.agreements?.[key]
                          ? 'bg-green-100 text-green-800'
                          : 'bg-gray-100 text-gray-800'
                      }`}>
                      {applicantData?.agreements?.[key]
                        ? 'Agreed'
                        : 'Not Agreed'}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </section>
        </div>
      )}
    </>
  );
}

export default MyApplications;
